import { ViewModel } from 'view_models/view_model'
import { AddressViewModel } from './address_view_model'
import { Organization } from 'entities/organization'

export class OrganizationViewModel extends ViewModel<Organization> {
    public addressVm = (): AddressViewModel => {
        return new AddressViewModel(this.object.address!)
    }
}
